import AllowedDimensions from "./AllowedDimensions";

export default class RouteEvent {
    public eventType: string;
    public isrs: string;
    public objectName: string;
    public eventMessage: string;

    public latitude: number;
    public longitude: number;

    public eta: Date;
    public etd: Date;

    public relativeDistance: number;
    public absoluteDistance: number;

    public dimensions: AllowedDimensions;
    public eventProperties: any;

    public constructor(data: any) {
        if (!data) {
            return;
        }
        this.eventType = data.EventType;
        this.isrs = data.ISRS;
        this.objectName = data.ObjectName;
        this.eventMessage = data.EventMessage;

        this.latitude = data.Latitude;
        this.longitude = data.Longitude;

        this.eta = new Date(data.ETA);
        this.etd = new Date(data.ETD);

        this.relativeDistance = data.RelativeDistance;
        this.absoluteDistance = data.AbsoluteDistance;

        this.dimensions = new AllowedDimensions(data.Dimensions);
        this.eventProperties = data.EventProperties;
    }
}